/**
 * Anything exported by this file will be added to `connfidoApplepaySDK` variable on window
 */

export const version = PACKAGE_VERSION;

export { initialize } from './initialize/initialize';

console.log(PACKAGE_NAME, PACKAGE_VERSION);
